module.exports = "/images/chevron-right.svg?0b085da17e102604a3a363a252a1dc21";